import { useApp } from '@/core/state/appStore'
import { Bewertungsbogen } from '../foerderplan/Bewertungsbogen'
import { Foerderplan } from '../foerderplan/Foerderplan'
import { Erstbericht } from '../erstbericht/Erstbericht'
import { GevaKlett } from '../geva-klett/GevaKlett'
import { gevaKlettTabs, useGevaKlettStatus } from '../geva-klett/useGevaKlettStatus'
import { Kompetenzbilanzierung } from './Kompetenzbilanzierung'

export function KompetenzfeststellungBox({ coachingId }: { coachingId: string | null }) {
  const { state } = useApp()
  const status = useGevaKlettStatus(coachingId)
  const tabs = gevaKlettTabs(status.status)
  switch (state.screen?.tab) {
    case 'jobcoach':
    case 'anleiter':
    case 'sprachlehrkraft':
      return <Bewertungsbogen key={state.screen?.tab} coachingId={coachingId} bogen={state.screen?.tab} tabs={tabs} />
    case 'kompetenzbilanzierung':
      return <Kompetenzbilanzierung coachingId={coachingId} tabs={tabs} />
    case 'foerderplan':
      return <Foerderplan coachingId={coachingId} tabs={tabs} />
    case 'erstbericht':
      return <Erstbericht coachingId={coachingId} tabs={tabs} />
    default:
      return <GevaKlett coachingId={coachingId} status={status} />
  }
}
